import { branding } from 'branding';

export const Footer = () => {
  return branding.footer;
};
